/* Featured collection (PDP) carousel arrows (moved from sections/featured-collection-pdp.liquid). */
(function () {
  function init(root) {
    var wrapper = root.querySelector('[data-fc-carousel]');
    var scroller = root.querySelector('[data-fc-scroller]');
    if (!wrapper || !scroller || wrapper.dataset.fcReady === 'true') return;
    var prevBtn = wrapper.querySelector('.fc-inn__chevron--prev');
    var nextBtn = wrapper.querySelector('.fc-inn__chevron--next');
    if (!prevBtn || !nextBtn) return;
    wrapper.dataset.fcReady = 'true';

    function updateArrowPosition() {
      var cards = Array.prototype.filter.call(scroller.children, function (card) {
        return card.offsetParent !== null;
      });
      if (!cards.length) return;
      var wrapperRect = wrapper.getBoundingClientRect();
      var scrollerRect = scroller.getBoundingClientRect();
      var firstCardRect = cards[0].getBoundingClientRect();
      wrapper.style.setProperty('--carousel-prev-left', scrollerRect.left - wrapperRect.left + 'px');
      wrapper.style.setProperty('--carousel-next-left', scrollerRect.right - wrapperRect.left - 10 + 'px');
      wrapper.style.setProperty('--carousel-arrow-top', firstCardRect.top - wrapperRect.top + firstCardRect.height / 2 + 'px');
    }

    function updateButtons() {
      var maxLeft = Math.round(scroller.scrollWidth - scroller.clientWidth);
      if (maxLeft <= 5) {
        prevBtn.style.display = 'none';
        nextBtn.style.display = 'none';
        prevBtn.disabled = true;
        nextBtn.disabled = true;
        return;
      }
      prevBtn.style.display = '';
      nextBtn.style.display = '';
      if (window.innerWidth <= 768) {
        prevBtn.disabled = true;
        nextBtn.disabled = true;
        return;
      }
      var left = Math.round(scroller.scrollLeft);
      prevBtn.disabled = left <= 30;
      nextBtn.disabled = left >= maxLeft - 30;
    }

    function update() {
      updateArrowPosition();
      updateButtons();
    }

    function updateAfterLayout() {
      requestAnimationFrame(function () {
        requestAnimationFrame(update);
      });
    }

    prevBtn.addEventListener('click', function () {
      if (window.innerWidth <= 768) return;
      scroller.scrollBy({ left: -scroller.clientWidth * 0.8, behavior: 'smooth' });
    });
    nextBtn.addEventListener('click', function () {
      if (window.innerWidth <= 768) return;
      scroller.scrollBy({ left: scroller.clientWidth * 0.8, behavior: 'smooth' });
    });

    scroller.addEventListener('scroll', updateButtons, { passive: true });

    // Measure once when the carousel first comes near the viewport, then only
    // when its boxes actually change size (ResizeObserver callbacks run after
    // layout, so these reads never force a synchronous layout). No polling.
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
        io.disconnect();
        update();
      }, { rootMargin: '300px 0px' });
      io.observe(wrapper);
    } else {
      updateAfterLayout();
    }
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(function () { update(); });
      ro.observe(wrapper);
      ro.observe(scroller);
      if (scroller.firstElementChild) ro.observe(scroller.firstElementChild);
    } else {
      window.addEventListener('resize', updateAfterLayout);
      window.addEventListener('load', updateAfterLayout);
    }
  }

  function initAll() { document.querySelectorAll('[data-inv-fc-pdp]').forEach(init); }
  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
